module.exports = __webpack_public_path__ + "1d544d385c681c51ab38ef3b399323b0.jpg";